import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edit-customer-page" }

import { ref, computed, onBeforeMount, inject } from "vue";
import { get, set } from "@vueuse/core";
import { useRoute } from "vue-router";
import Form from "../common/form.vue";
import Trash from "../common/trash.vue";
import rulesFn from "../common/rules";
import { ApiCustomerShowReq, ICustomer } from "@/clinic/typings";
import { CustomerServices } from "@/clinic/services";
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const customer = ref<ICustomer>({} as ICustomer);
const toast = useToast();

const idUrl = computed((): number => {
  const { params } = route;
  const { id } = params;
  return id as unknown as number;
});

const customerParams = async (): Promise<ApiCustomerShowReq> => ({
  id: get(idUrl),
  clinic_id: get(await get(clinicId)) as number,
});

const onTrash = async () => {
  await CustomerServices.trashCustomer(
    await customerParams(),
    () => notifySuccessMsg(toast, "成功"),
    () => notityErrorMsg(toast, "エラー")
  );
};

const clinicId = ref(0);

const getCustomer = async () => {
  const { data: customerRes } = await CustomerServices.getCustomer(await customerParams());
  set(customer, get(customerRes) as unknown as ICustomer);
};

onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));
  await getCustomer();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Trash, {
        id: _unref(get)(_unref(idUrl)),
        onTrash: onTrash
      }, null, 8, ["id"]),
      _createVNode(Form, {
        rules: _unref(rulesFn)(true),
        hasEdit: true,
        model: customer.value,
        clinicId: clinicId.value
      }, null, 8, ["rules", "model", "clinicId"])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})